import Cookies from 'js-cookie';
import { setCookie } from "./index";
import i18n from '@/i18n';
var LangKey = 'localeData'; // 和luu-ui内部一直

export function getLang() {
  return Cookies.get(LangKey);
}
export function setLang(Lang) {
  return setCookie(LangKey, Lang);
}
export function removeLang() {
  return Cookies.remove(LangKey);
}
export function changeLang(lang) {
  i18n.locale = lang;
  setLang(lang);
  location.reload(); // todo fix switch lang reload
}